module.exports = __webpack_public_path__ + "static/media/TN-Men-Pants.538ce3c5.svg";